import { styled as MuiStyled } from "@mui/system";
import { colors } from "../../../utils";
import styled from "styled-components";

export const CardContainer = MuiStyled("div")(({ background }) => ({
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  background: background,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
  paddingLeft: "0px",
  overflow: "hidden",
  minWidth: 0,
  margin: 0,
  // cursor: "pointer",
}));

export const ContentWrapper = MuiStyled("div")({
  height: "100%",
  // padding: "50px 0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const TextWrapper = MuiStyled("div")({
  margin: "0px 20px",
});

export const WrapperGrid = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  min-width: 0;
`;

export const WheelView = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
`;

export const ContentView = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  height: 100%;
  min-height: 25vh;
  padding: 10px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;
